/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function ArrowRestartIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <mask
        id='arrow-restart_svg__a'
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill='#D9D9D9' d='M0 0h24v24H0z' />
      </mask>
      <g mask='url(#arrow-restart_svg__a)'>
        <path
          fill='#232B3A'
          d='M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4q-1.725 0-3.3.713A7.6 7.6 0 0 0 6 6.75V4H4v7h7V9H6.8a5.84 5.84 0 0 1 2.187-2.2A5.93 5.93 0 0 1 12 6q2.5 0 4.25 1.75T18 12t-1.75 4.25T12 18a5.86 5.86 0 0 1-3.475-1.1A5.8 5.8 0 0 1 6.35 14h-2.1q.7 2.65 2.85 4.325T12 20'
        />
      </g>
    </svg>
  )
}
